import { render, staticRenderFns } from "./MatterSupremeCourtList.vue?vue&type=template&id=1dd66692&"
import script from "./MatterSupremeCourtList.vue?vue&type=script&lang=js&"
export * from "./MatterSupremeCourtList.vue?vue&type=script&lang=js&"
import style0 from "./MatterSupremeCourtList.vue?vue&type=style&index=0&id=1dd66692&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports